<template>
  <b-container>
    <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
      <h3>Artikel:</h3>
      <div>
        <b-button variant="outline-primary" to="Artikel/Neu">Erstellen</b-button>
      </div>
    </b-row>
    <hr class="mt-4 mb-4">
    <div class="overflow-auto">
      <b-pagination-nav
          :link-gen="linkGen"
          :number-of-pages="pages"
          align="fill"
          use-router
      />
    </div>
    <b-list-group
        class="list"
        flush
    >
      <b-list-group-item
          v-for="article in articles"
          :key="article.id"
          :to="{ path: `/Artikel/${article.id}`}"
          class="flex-column align-items-start"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1 text-primary">
            {{ article.title }}
          </h5>
          <small class="text-muted createdDate">{{ article.created_at }}</small>
        </div>

        <p class="mb-1" v-html="article.preview"/>
      </b-list-group-item>
    </b-list-group>
  </b-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ArtikelListe',
  computed: {
    ...mapGetters([
      'getStoredArticlesByPage',
      'getArticlePages'
    ]),
    articles() {
      return this.getStoredArticlesByPage(parseInt(this.$route.query.page))
    },
    pages() {
      return this.getArticlePages
    },
  },
  watch: {
    '$route.query.page'() {
      this.$store.dispatch('getArticles', this.$route.query.page)
    }
  },
  mounted() {
    this.$store.dispatch('getArticles', this.$route.query.page)
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    }
  }
}
</script>

<style scoped>
.createdDate {
  flex: inherit !important;
}

.list {
  border: 1px lightgrey solid;
}
</style>
